// extracted by mini-css-extract-plugin
export default {"root":"StudentsTable_root__hcPEV","operation":"StudentsTable_operation__wagoH","column":"StudentsTable_column__6BlbR"};